import { Button } from "antd";
import { useEffect } from "react";
import { useAppSelector } from "../../../app/store";
import { useSocket } from "../../../contexts/SocketContext";
import useModal from "../../../hooks/useModal";
import CreateTeamModal from "./CreateTeamModal";
import NewChatModal from "./NewChatModal";

export default function ConversationHomepage() {
  const {
    open: openCreateTeamModal,
    handleOpen: handleCreateTeamOpen,
    handleClose: handleCreateTeamClose,
  } = useModal<undefined, "CREATE_TEAM">();

  const {
    open: openNewChatModal,
    handleOpen: handleNewChatOpen,
    handleClose: handleNewChatClose,
  } = useModal<undefined, "NEW_CHAT">();

  const auth = useAppSelector((state) => state.auth);
  const { socket, registerUser, registerSuccess } = useSocket();

  useEffect(() => {
    if (auth?.user?.id) {
      registerUser(auth?.user?.id);

      socket?.on("registerSuccess", () => {
        registerSuccess(Number(auth?.user?.id), 17); // Todo: Need to change the number: 17
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, auth?.user?.id]);

  return (
    <div className="bg-[#F9FAFB] h-[calc(100vh-8rem)] flex justify-center items-center text-center">
      <div>
        <div className="text-[24px] text-[#2D3643]">
          The Power of Collaboration
        </div>
        <div className="text-[#455468]">
          <span className="block">
            Big achievements start with small conversations. Dive in,
          </span>{" "}
          <span>share your thoughts, and watch ideas take flight!</span>
        </div>
        <div className="flex gap-2 justify-center mt-4">
          <Button
            className="bg-[#F0F3F9] !border-[#D7DFE9] font-semibold !text-[#2D3643]"
            onClick={() => handleCreateTeamOpen({ type: "CREATE_TEAM" })}
          >
            Create a new group
          </Button>
          <Button
            className="bg-[#F0F3F9] !border-[#D7DFE9] font-semibold !text-[#2D3643]"
            onClick={() => handleNewChatOpen({ type: "NEW_CHAT" })}
          >
            New chat
          </Button>
        </div>
      </div>

      {openCreateTeamModal.type === "CREATE_TEAM" && (
        <CreateTeamModal
          handleClose={handleCreateTeamClose}
          open={openCreateTeamModal.open}
        />
      )}
      {openNewChatModal.type === "NEW_CHAT" && (
        <NewChatModal
          open={openNewChatModal.open}
          handleClose={handleNewChatClose}
        />
      )}
    </div>
  );
}
